"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const ArrowUpward = createSvgIcon(
  <path
    d="M12.5 6.92115L12.5 19L11.5 19L11.5 6.92115L5.7077 12.7135L5 12L12 5L19 12L18.2923 12.7135L12.5 6.92115Z"
    fill="#1E2C3F"
  />,
  "ArrowUpward",
)

const ArrowUpwardIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary
  return <ArrowUpward sx={{ fill: _fill, ...sx }} {...rest} />
}

export default ArrowUpwardIcon
